import { atom } from 'recoil';

const createDefaultMortgageInfo = () => ({
  preRequestSeq: null,
  purposeCd: { text: '', value: '' },
  haveCnt: { text: '', value: '' },
  firstYn: { text: '', value: ''},
  disposalPlanYn: '',
  houseType: { text: '', value: '' },
  apartment: { text: '', value: '', desc: false }, // 아파트 명, 아파트 코드, 규제지역 여부
  rateSeq: {text:'', value:''},
  ldongCode: { text: '', value: '' },
  floor: { text: '', value: '' },
  dong: '',
  ho: '',
  housePrice: '',
  hopefulAmt: null,
  previousYn: { text: '', value: '' },
  previousAmt: null,
  tenantYn: { text: '', value: '' },
  tenantAmt: null,
  marriageCd: { text: '', value: '' },
  jobType: { text: '', value: '' },
  openDt: { text: '', value: '' },
  salaryAmt: null,
  credPoint: null,

  unkAddress: 'N',
  address: '',
  isRegulation: false
});

const resetAmtUnit = (housePreRequestInfoData: any) => {
  housePreRequestInfoData.hopefulAmt = housePreRequestInfoData.hopefulAmt ? housePreRequestInfoData.hopefulAmt / 10000 : housePreRequestInfoData.hopefulAmt;
  housePreRequestInfoData.previousAmt = housePreRequestInfoData.previousAmt ? housePreRequestInfoData.previousAmt / 10000 : housePreRequestInfoData.previousAmt;
  housePreRequestInfoData.tenantAmt = housePreRequestInfoData.tenantAmt ? housePreRequestInfoData.tenantAmt / 10000 : housePreRequestInfoData.tenantAmt;
  housePreRequestInfoData.salaryAmt = housePreRequestInfoData.salaryAmt ? housePreRequestInfoData.salaryAmt / 10000 : housePreRequestInfoData.salaryAmt;
  housePreRequestInfoData.houseAmt = housePreRequestInfoData.houseAmt ? housePreRequestInfoData.houseAmt / 10000 : housePreRequestInfoData.houseAmt;

  return housePreRequestInfoData;
}

const mortgageInfo = atom<any>({
  key: 'mortgageInfo',
  default: createDefaultMortgageInfo(),
});


export { mortgageInfo, createDefaultMortgageInfo, resetAmtUnit };
